import * as React from 'react'
import styled, { css } from 'styled-components'
import { ColorName, Colors, LightColors } from '../constants'

export type CheckState = 'checked' | 'unchecked' | 'indeterminate'

export interface CheckboxProps {
  check: CheckState
  color?: ColorName
  disabled?: boolean
  onClick?: () => void
}

export default function Checkbox(props: CheckboxProps) {
  const { check, color, disabled, onClick, ...rest } = props

  let body = null
  let fill = false
  if (check === 'checked') {
    fill = true
  } else if (check === 'indeterminate') {
    body = <Circle />
  }

  return (
    <CheckDiv color={color || 'silver'} disabled={disabled || false} fillBg={fill} onClick={onClick} {...rest}>
      {body}
    </CheckDiv>
  )
}

const Circle = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 3px;
  margin-top: 2px;
`

const CheckDiv = styled.div`
  ${(props: { color: ColorName; disabled: boolean; fillBg: boolean }) => css`
    border: 2px solid ${Colors[props.color]};
    color: ${Colors[props.color]};
    ${props.fillBg && `background-color: ${Colors[props.color]};`}
    display: inline-block;
    vertical-align: middle;
    width: 14px;
    height: 14px;
    padding: 0 0 2px 2px;
    box-sizing: border-box;
    border-radius: 4px;
    margin-right: 4px;
    font-weight: 500;

    & ${Circle} {
      background: ${Colors[props.color]};
    }

    ${!props.disabled &&
    css`
      cursor: pointer;
      &:hover {
        border-color: ${LightColors[props.color]};
        color: ${LightColors[props.color]};
        ${props.fillBg && `background-color: ${LightColors[props.color]};`}

        & ${Circle} {
          background: ${LightColors[props.color]};
        }
      }
    `}
  `}
`
